"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createFromAxiosError = exports.createFromGraphqlError = exports.createFromApolloError = exports.isError = exports.isRedirectToSignInPage = exports.isRedirect = exports.doRedirect = exports.getStatusCodeFromErrorType = void 0;
const isEmpty_1 = __importDefault(require("lodash/isEmpty"));
const isNil_1 = __importDefault(require("lodash/isNil"));
const constants_1 = require("../../constants");
const utils_1 = require("../../utils");
const types_1 = require("./types");
const getStatusCodeFromErrorType = (type) => {
    switch (type) {
        case types_1.ErrorType.AUTHENTICATION_FAILED_ERROR:
            return 401;
        case types_1.ErrorType.CLIENT_SIDE_NETWORK_ERROR:
        case types_1.ErrorType.INVALID_INPUT_ERROR:
            return 400;
        case types_1.ErrorType.MULTI_FACTOR_PAYMENT_AUTHENTICATION_EXCEPTION:
        case types_1.ErrorType.PAYMENT_INSTRUMENT_ERROR:
            return 402;
        case types_1.ErrorType.NOT_FOUND_ERROR:
            return 404;
        case types_1.ErrorType.UNEXPECTED_ERROR:
            return 500;
        case types_1.ErrorType.SHOPPING_PORTAL_REDIRECT_ERROR:
            return 307;
    }
};
exports.getStatusCodeFromErrorType = getStatusCodeFromErrorType;
const ERROR_TYPES = (0, utils_1.getValuesOfStringEnum)(types_1.ErrorType);
const doRedirect = (detailPageRes, req, res) => {
    var _a, _b;
    const redirectPrefix = constants_1.SHOPPING_PORTAL_PREFIX;
    const searchParams = new URLSearchParams((_a = req === null || req === void 0 ? void 0 : req.url) === null || _a === void 0 ? void 0 : _a.split('?')[1]);
    searchParams.set('tenantId', detailPageRes.tenantId);
    const redirectURL = redirectPrefix + ((_b = req === null || req === void 0 ? void 0 : req.url) === null || _b === void 0 ? void 0 : _b.split('?')[0]) + '?' + searchParams.toString();
    res === null || res === void 0 ? void 0 : res.writeHead(302, {
        Location: redirectURL,
        'x-amazon-internal-redirect': '1',
        'x-amazon-redirect-ignore-cookie': '1'
    });
    res === null || res === void 0 ? void 0 : res.end();
};
exports.doRedirect = doRedirect;
const isRedirect = (redirectError) => {
    return redirectError.name == types_1.ErrorType.SHOPPING_PORTAL_REDIRECT_ERROR;
};
exports.isRedirect = isRedirect;
const isRedirectToSignInPage = (error) => {
    return error.name == types_1.ErrorType.AUTHENTICATION_FAILED_ERROR;
};
exports.isRedirectToSignInPage = isRedirectToSignInPage;
const isError = (error) => error.message !== undefined && ERROR_TYPES.includes(error.name);
exports.isError = isError;
const createFromApolloError = (apolloError) => {
    const gqlErrors = apolloError.graphQLErrors;
    if ((0, isNil_1.default)(gqlErrors) || (0, isEmpty_1.default)(gqlErrors)) {
        return {
            message: apolloError.message,
            name: types_1.ErrorType.UNEXPECTED_ERROR
        };
    }
    return (0, exports.createFromGraphqlError)(gqlErrors[0]);
};
exports.createFromApolloError = createFromApolloError;
const createFromGraphqlError = (gqlError) => {
    var _a;
    const { name, data } = (_a = gqlError.extensions) !== null && _a !== void 0 ? _a : {};
    return {
        data,
        message: gqlError.message,
        name: name !== null && name !== void 0 ? name : types_1.ErrorType.UNEXPECTED_ERROR
    };
};
exports.createFromGraphqlError = createFromGraphqlError;
const createFromAxiosError = (axiosError) => {
    var _a, _b, _c, _d;
    const { response } = axiosError;
    if ((0, isNil_1.default)(response)) {
        return {
            message: 'AxiosError.response is missing',
            name: types_1.ErrorType.UNEXPECTED_ERROR
        };
    }
    const responseData = response.data;
    const errorType = (_c = (_b = (_a = responseData === null || responseData === void 0 ? void 0 : responseData.name) !== null && _a !== void 0 ? _a : responseData === null || responseData === void 0 ? void 0 : responseData.type) !== null && _b !== void 0 ? _b : responseData) !== null && _c !== void 0 ? _c : '';
    const message = (_d = responseData === null || responseData === void 0 ? void 0 : responseData.message) !== null && _d !== void 0 ? _d : '';
    if (ERROR_TYPES.includes(errorType)) {
        return {
            message,
            data: responseData === null || responseData === void 0 ? void 0 : responseData.data,
            name: errorType
        };
    }
    let errorTypeFromStatusCode = types_1.ErrorType.UNEXPECTED_ERROR;
    switch (response.status) {
        case 400:
            errorTypeFromStatusCode = types_1.ErrorType.INVALID_INPUT_ERROR;
            break;
        case 401:
        case 403:
            errorTypeFromStatusCode = types_1.ErrorType.AUTHENTICATION_FAILED_ERROR;
            break;
        case 402:
            errorTypeFromStatusCode = types_1.ErrorType.PAYMENT_INSTRUMENT_ERROR;
            break;
        case 404:
            errorTypeFromStatusCode = types_1.ErrorType.NOT_FOUND_ERROR;
            break;
    }
    return {
        message,
        name: errorTypeFromStatusCode
    };
};
exports.createFromAxiosError = createFromAxiosError;
__exportStar(require("./types"), exports);
